const SocketAction = {
    TYPING: "typing",
    READED: "readed",
    MESSAGE: "message",
    ONLINE_USER: "onlineUser",
    MESSAGE_FILE: "messageFile",
    GET_ONLINE_USER: "getOnlineUser",
    UNREAD_CHAT_COUNT: "unreadChatCount",
}

export default SocketAction
